<div class="section d-flex justify-content-between">
  <button
    class="btn btn--paybee btn-xs modal-primary-button mb-2"
    (click)="addRegistrationButton()"
  > Add Button</button>
</div>

<ng-container *ngIf="(registrations && (registrations.length > 0)); else no_content">
  <ng-container [formGroup]="form">
    <ul class="list-group ui-sortable" formArrayName="buttons" cdkDropList (cdkDropListDropped)="dropOption($event)">
      @for(registration of registrations; let index = $index; track registration.id) {
        <app-registration-button [registration]="registration" [index]="index" [eventPageId]="eventPageId"></app-registration-button>
      }
    </ul>
  </ng-container>
</ng-container>
<ng-template #no_content>
    <div class="empty py-4">
      Click <div style="font-weight: bold;padding: 0 4px"> Add </div> to start adding your registration blocks
    </div>
</ng-template>
